import {
  LayoutDashboard,
  Users,
  GraduationCap,
  ClipboardCheck,
  Wallet,
  ScrollText,
  Boxes,
  UserSquare2,
  MessageSquareWarning,
  Bell,
  ScanLine,
  BookOpenCheck,
  Building2,
  Wrench,
  Settings,
  ShieldCheck,
  IdCard,
  Library,
  Users2,
  BookOpen,
  ClipboardList,
  Award,
  LayoutList,
  SlidersHorizontal,
  Network,
  Siren,
  Clock3,
} from "lucide-react";

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  director: "Director",
  teacher: "Teacher",
  accountant: "Accountant",
  receptionist: "Receptionist",
  parent: "Parent",
  student: "Student",
  attendance_officer: "Attendance Officer",
  inventory_officer: "Inventory Officer",
};

// Permissions: which roles can see which menu item
export const NAV_ITEMS = [
  { key: "termly-entitlements", label: "Termly Entitlements", to: "/app/inventory/entitlements", icon: Boxes, roles: [], capabilities: ["inventory.entitlement.manage", "inventory.entitlement.override", "inventory.issue", "inventory.view_history"] },
  {
    key: "overview",
    label: "Overview",
    to: "/app",
    icon: LayoutDashboard,
    roles: "all",
  },
  {
    key: "reports",
    label: "Reports",
    to: "/app/reports",
    icon: Siren,
    capabilities: [
      "report.create",
      "report.view_own",
      "report.view_assigned",
      "report.view_unit",
      "report.view_institution",
    ],
    roles: [],
  },
  {
    key: "students",
    label: "Students",
    to: "/app/students",
    icon: GraduationCap,
    roles: [
      "super_admin",
      "director",
      "teacher",
      "receptionist",
      "accountant",
      "attendance_officer",
      "parent",
      "student",
    ],
  },
  {
    key: "guardians",
    label: "Guardians",
    to: "/app/guardians",
    icon: Users2,
    roles: ["super_admin", "director", "receptionist"],
  },
  {
    key: "promotion",
    label: "Promotion",
    to: "/app/promotion",
    icon: GraduationCap,
    roles: ["super_admin", "director"],
  },
  {
    key: "programs",
    label: "Programs",
    to: "/app/programs",
    icon: Library,
    roles: ["super_admin", "director"],
  },
  {
    key: "staff",
    label: "Staff",
    to: "/app/staff",
    icon: Users,
    roles: ["super_admin", "director", "accountant"],
  },
  {
    key: "attendance",
    label: "Attendance",
    to: "/app/attendance",
    icon: ClipboardCheck,
    roles: ["super_admin", "director", "teacher", "attendance_officer"],
  },
  {
    key: "staff-attendance",
    label: "Staff Attendance",
    to: "/app/staff-attendance",
    icon: Clock3,
    capabilities: ["attendance.staff.clock","attendance.staff.view_own","attendance.staff.view_unit","attendance.staff.view_institution"],
    roles: [],
  },
  {
    key: "qr-scan",
    label: "QR Scanner",
    to: "/app/qr-scan",
    icon: ScanLine,
    roles: [
      "super_admin",
      "director",
      "teacher",
      "attendance_officer",
      "receptionist",
    ],
  },
  {
    key: "fees",
    label: "Fees & POS",
    to: "/app/fees",
    icon: Wallet,
    roles: [
      "super_admin",
      "director",
      "accountant",
      "receptionist",
      "parent",
      "student",
    ],
  },
  {
    key: "payment-status",
    label: "Payment Status",
    to: "/app/fees/class-summary",
    icon: Wallet,
    capabilities: ["finance.payment_status.view_class"],
    roles: [],
  },
  {
    key: "exams",
    label: "Examinations",
    to: "/app/exams",
    icon: BookOpenCheck,
    roles: ["super_admin", "director", "teacher", "student", "parent"],
  },
  {
    key: "subjects",
    label: "Subjects",
    to: "/app/subjects",
    icon: BookOpen,
    roles: ["super_admin", "director", "teacher"],
  },
  {
    key: "score-entry",
    label: "Score Entry",
    to: "/app/score-entry",
    icon: ClipboardList,
    roles: ["super_admin", "director", "teacher"],
  },
  {
    key: "report-cards",
    label: "Report Cards",
    to: "/app/report-cards",
    icon: Award,
    roles: ["super_admin", "director", "teacher", "parent", "student"],
  },
  {
    key: "broadsheet",
    label: "Broadsheet",
    to: "/app/broadsheet",
    icon: LayoutList,
    roles: ["super_admin", "director", "teacher"],
  },
  {
    key: "assessment-config",
    label: "Assessment Config",
    to: "/app/assessment-config",
    icon: SlidersHorizontal,
    roles: ["super_admin", "director"],
  },
  {
    key: "idcards",
    label: "ID Cards",
    to: "/app/id-cards",
    icon: IdCard,
    capability: "id_card.view",
    roles: ["super_admin", "director", "receptionist", "teacher"],
  },
  {
    key: "inventory",
    label: "Consumables",
    to: "/app/inventory",
    icon: Boxes,
    roles: ["super_admin", "director", "inventory_officer", "accountant"],
  },
  {
    key: "assets",
    label: "Fixed Assets",
    to: "/app/assets",
    icon: Boxes,
    roles: ["super_admin", "director", "inventory_officer", "accountant"],
  },
  {
    key: "visitors",
    label: "Visitors",
    to: "/app/visitors",
    icon: UserSquare2,
    roles: ["super_admin", "director", "receptionist"],
  },
  {
    key: "complaints",
    label: "Complaints",
    to: "/app/complaints",
    icon: MessageSquareWarning,
    roles: "all",
  },
  {
    key: "notifications",
    label: "Notifications",
    to: "/app/notifications",
    icon: Bell,
    roles: "all",
  },
  {
    key: "rooms",
    label: "Meeting Rooms",
    to: "/app/rooms",
    icon: Building2,
    roles: ["super_admin", "director", "teacher", "accountant", "receptionist"],
  },
  {
    key: "maintenance",
    label: "Maintenance",
    to: "/app/maintenance",
    icon: Wrench,
    roles: "all",
  },
  {
    key: "organisation",
    label: "Organisation",
    to: "/app/organisation",
    icon: Network,
    roles: ["super_admin", "director"],
    capability: "organisation.view",
  },
  {
    key: "users",
    label: "User Accounts",
    to: "/app/users",
    icon: ShieldCheck,
    roles: ["super_admin", "director"],
  },
  {
    key: "audit",
    label: "Audit Logs",
    to: "/app/audit",
    icon: ScrollText,
    roles: ["super_admin", "director"],
  },
  {
    key: "settings",
    label: "Settings",
    to: "/app/settings",
    icon: Settings,
    roles: "all",
  },
];

export const canSee = (item, role, roles, effectiveCapabilities = []) => {
  const userRoles =
    Array.isArray(roles) && roles.length > 0 ? roles : role ? [role] : [];
  if (userRoles.includes("super_admin")) return true;
  const capabilityByKey = {
    students: ["student.view"], guardians: ["guardian.view"], promotion: ["promotion.execute"], programs: ["organisation.manage"],
    staff: ["staff.view_directory", "staff.manage"], attendance: ["attendance.view", "attendance.mark"], "qr-scan": ["attendance.mark"],
    fees: ["finance.account.view"], exams: ["assessment.view"], subjects: ["assessment.view", "subject.manage"],
    "score-entry": ["assessment.enter_marks"], "report-cards": ["assessment.view"], broadsheet: ["assessment.review", "assessment.publish"],
    "assessment-config": ["assessment.configure"], inventory: ["inventory.view"], assets: ["asset.view"], visitors: ["visitor.manage"],
    rooms: ["asset.view"], maintenance: ["asset.view", "asset.manage"], users: ["user.manage"], audit: ["finance.audit.view", "role.administer"],
  };
  const mapped = capabilityByKey[item.key];
  if (mapped) return mapped.some((capability) => effectiveCapabilities.includes(capability));
  const requiredCapabilities = item.capabilities || (item.capability ? [item.capability] : []);
  if (requiredCapabilities.length) {
    return requiredCapabilities.some((capability) => effectiveCapabilities.includes(capability));
  }
  if (item.roles === "all") return ["overview", "notifications", "settings"].includes(item.key);
  return userRoles.some((r) => item.roles.includes(r));
};

export const ROLE_PRIORITY = [
  "super_admin",
  "director",
  "accountant",
  "teacher",
  "attendance_officer",
  "inventory_officer",
  "receptionist",
  "parent",
  "student",
];

export const primaryRole = (roles) => {
  if (!Array.isArray(roles) || roles.length === 0) return "";
  for (const r of ROLE_PRIORITY) if (roles.includes(r)) return r;
  return roles[0];
};

export const NAV_GROUPS = [
  {
    label: "Main",
    items: ["overview"],
  },

  {
    label: "Academics",
    items: [
      "students",
      "promotion",
      "programs",
      "subjects",
      "exams",
      "score-entry",
      "report-cards",
      "broadsheet",
      "assessment-config",
    ],
  },

  {
    label: "People",
    items: ["staff", "guardians", "organisation", "users", "idcards"],
  },

  {
    label: "Operations",
    items: [
      "attendance",
      "staff-attendance",
      "qr-scan",
      "fees",
      "payment-status",
      "inventory",
      "termly-entitlements",
      "assets",
      "visitors",
      "rooms",
      "maintenance",
    ],
  },

  {
    label: "Communication",
    items: ["complaints", "reports", "notifications"],
  },

  {
    label: "Security",
    items: ["audit", "settings"],
  },
];

const FRONTEND_CAPABILITIES = {
  super_admin: ["*"],
  director: ["organisation.view", "organisation.manage", "organisation.assignment.manage", "organisation.delegation.manage"],
};

export const hasCapability = (user, capability) => {
  if ((user?.effective_capabilities || []).includes(capability)) return true;
  const roles = Array.isArray(user?.roles) && user.roles.length ? user.roles : user?.role ? [user.role] : [];
  return roles.some((role) => FRONTEND_CAPABILITIES[role]?.includes("*") || FRONTEND_CAPABILITIES[role]?.includes(capability));
};
